import "core-js/modules/es.function.name.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import TooltipButton from 'components/TooltipButton';
import { MenuButton } from 'components/Menu';
import { jsx as _jsx } from "react/jsx-runtime";
// Adjust the horizontal offset of the button depending
// on the available space. The first value of the returned tuple
// is the offset on mobile, the second on desktop.
function getHorizontalOffset(level) {
  return level === 0 ? ['-xxs', 'xs'] : ['-xs', 0];
}
getHorizontalOffset.breakpoint = 'xs';
export function FloatingMoveButton(_ref) {
  var name = _ref.name,
    onClick = _ref.onClick,
    level = _ref.level;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(TooltipButton, {
    round: true,
    iconOnly: true,
    icon: "arrow-right",
    variant: "transparent",
    onClick: onClick,
    title: t('actions_move_selected_above', {
      name: name
    }),
    ml: getHorizontalOffset(level),
    breakpoints: getHorizontalOffset.breakpoint,
    children: t('actions_move_selected_above', {
      name: name
    })
  });
}
export function FloatingAddContentButton(_ref2) {
  var name = _ref2.name,
    level = _ref2.level;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  return /*#__PURE__*/_jsx(MenuButton, {
    as: TooltipButton,
    round: true,
    iconOnly: true,
    icon: "plus",
    variant: "transparent",
    title: t('actions_add_content_above', {
      name: name
    }),
    ml: getHorizontalOffset(level),
    breakpoints: getHorizontalOffset.breakpoint,
    children: t('actions_add_content_above', {
      name: name
    })
  });
}
export function FloatingAddSectionButton(_ref3) {
  var name = _ref3.name,
    onClick = _ref3.onClick,
    level = _ref3.level;
  var _useTranslation3 = useTranslation(),
    t = _useTranslation3.t;
  var buttonLabel = level === 0 ? t('actions_add_section_above', {
    name: name
  }) : t('actions_add_subsection_above', {
    name: name
  });
  return /*#__PURE__*/_jsx(TooltipButton, {
    round: true,
    iconOnly: true,
    icon: "plus",
    variant: "transparent",
    onClick: onClick,
    title: buttonLabel,
    ml: getHorizontalOffset(level),
    breakpoints: getHorizontalOffset.breakpoint,
    children: buttonLabel
  });
}